import removeMarkdown from "remove-markdown";

interface TransformedItem {
  name: string;
  [key: string]: number | string | undefined;
}

export function transformData(data: any[]): TransformedItem[] {
  const transformed: { [key: string]: TransformedItem } = {};

  data.forEach((item) => {
    item.orders.forEach((orderInfo: { order: any; orderCount: any }) => {
      const orderNumber = orderInfo.order;
      const value = item.value;
      const count = orderInfo.orderCount;

      if (!transformed[orderNumber]) {
        transformed[orderNumber] = { name: orderNumber };
      }

      transformed[orderNumber][value] = count;
    });
  });

  return Object.values(transformed).sort((a, b) => parseInt(a.name) - parseInt(b.name));
}

export const stripMarkdown = (input: string): string => {
  let strippedText = removeMarkdown(input);

  const tempElement = document.createElement("div");
  tempElement.innerHTML = strippedText;
  strippedText = tempElement.textContent || tempElement.innerText || strippedText;

  return strippedText;
};
